import { LitElement, html, css } from 'lit-element';

export class Tooltip extends LitElement {
  static get properties() {
    return {
      trigger: { type: String, attribute: false },
      content: { type: String, attribute: false }
    };
  }

  static get styles() {
    return css`
      :host[hidden] {
        display: none;
      }

      :host {
        display: inline-block;
      }

      .og-tooltip {
        cursor: pointer;
        display: inline-block;
        -webkit-transform: translateZ(0);
      }

      .og-tooltip .og-tooltip__content {
        font-family: var(--og-tooltip-font-familiy, inherit);
        font-size: var(--og-tooltip-font-size, inherit);
        color: var(--og-tooltip-font-color, inherit);
        background: #ececec;
        bottom: 100%;
        display: block;
        left: -25px;
        margin-bottom: 15px;
        min-width: 200px;
        opacity: 0;
        padding: 20px;
        pointer-events: none;
        position: absolute;
        width: 100%;
        -webkit-transform: translateY(10px);
        -moz-transform: translateY(10px);
        -ms-transform: translateY(10px);
        -o-transform: translateY(10px);
        transform: translateY(10px);
        -webkit-transition: all 0.25s ease-out;
        -moz-transition: all 0.25s ease-out;
        -ms-transition: all 0.25s ease-out;
        -o-transition: all 0.25s ease-out;
        transition: all 0.25s ease-out;
        -webkit-box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.28);
        -moz-box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.28);
        -ms-box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.28);
        -o-box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.28);
        box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.28);
      }

      .og-tooltip .og-tooltip__content:before {
        bottom: -20px;
        content: ' ';
        display: block;
        height: 20px;
        left: 0;
        position: absolute;
        width: 100%;
      }

      .og-tooltip .og-tooltip__content:after {
        border-left: solid transparent 10px;
        border-right: solid transparent 10px;
        border-top: solid #ececec 10px;
        bottom: -10px;
        content: ' ';
        height: 0;
        left: 50%;
        margin-left: -13px;
        position: absolute;
        width: 0;
      }

      .og-tooltip:hover .og-tooltip__content {
        opacity: 1;
        pointer-events: auto;
        -webkit-transform: translateY(0px);
        -moz-transform: translateY(0px);
        -ms-transform: translateY(0px);
        -o-transform: translateY(0px);
        transform: translateY(0px);
      }
    `;
  }

  render() {
    return html`
      <div class="og-tooltip">
        <slot name="trigger">
          ${this.trigger}
        </slot>
        <div class="og-tooltip__content">
          <slot name="content">
            ${this.content}
          </slot>
        </div>
      </div>
    `;
  }
}

export default Tooltip;
